import { render, staticRenderFns } from "./BudgetSimulationDetails.vue?vue&type=template&id=79c1ccd9&scoped=true&"
import script from "./BudgetSimulationDetails.vue?vue&type=script&lang=js&"
export * from "./BudgetSimulationDetails.vue?vue&type=script&lang=js&"
import style0 from "./BudgetSimulationDetails.vue?vue&type=style&index=0&id=79c1ccd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c1ccd9",
  null
  
)

export default component.exports